import React from "react";
import { BrowserRouter as Router, Route, Routes, useLocation } from 'react-router-dom';
import './App.css';
import Opening from './opening/opening';
import MainPage from './mainpage/main';
import { useEffect, useState } from 'react';
import Sidebar from "./sidebar/sidebar";
import Accountability from "./Accountability/Accountability";
import Transparency from "./Transparency/Transparency";
import Fairness from "./Fairness/Fairness";
import Reliability from "./Reliability/Reliability";
import Privacy from "./Privacy/Privacy";
import Inclusiveness from "./Inclusiveness/Inclusiveness";
import Risk_Management from "./Risk_Management/Risk_Management";
import Impact from "./Impact/Impact";
import Data_Quaility_Framework from "./Data_Quaility_Framework/Data_Quaility_Framework";
import SignIn from "./Auth/SignIn";
import SignUp from "./Auth/SignUp";
import ForgotPassword from "./AccountManagement/ForgotPass";
import AccountManage from "./AccountManagement/AccountManage";
import { ProtectedRoutes } from "./Auth/ProtectedRoutes";
import { onAuthStateChanged } from 'firebase/auth';
import { auth } from './Firebase_Config/firebase';
import Assessment from "./Assessments/Assessment";
import ThreatAssessment from "./Assessments/ThreatAssessment";
import CohereInterface from "./AIChat/AiTextGen";
import Dashboard from "./dash/Dashboard";
import AdminDashboard from "./AdminDashboard/AdminDashboard";
import AdminThreatAssessment from "./AdminDashboard/AdminThreatAssessment";
import AdminConformityAssessment from "./AdminDashboard/AdminConformity";
import AdminDashDashboard from "./AdminDashboard/Admin_DashDashboard";
import ProfilerOpening from "./DataProfiler/ProfilerLanding/ProfilerLanding";
import ImagesPage from "./DataProfiler/Images/images";
import TabularPage from "./DataProfiler/Tabular/tabular";
import ThreatIntel from "./ThreatIntelligence/ThreatIntelligence";
import ModelEvaluation from "./ModelEvaluation/ModelEvaluation";
import PrivacyMeter from "./PrivacyMeter/PrivacyMeter";
import DataSecurity from "./DataSecurity/DataSecurity";
import SecAIPage from "./SecAIPage/SecAIPage";
import FederatedLearning from "./FederatedLearning/FederatedLearning";
import Support from "./HelpPage/Support/Support";
import SecurityEducation from "./HelpPage/SecurityEducation/SecurityEducation";
import EducationVideos from "./HelpPage/SecurityEducation/EducationVideos";
import GeneralAI from "./HelpPage/GeneralAI/GeneralAI";
import DataEthics from "./HelpPage/DataEthics/DataEthics";
import ResponsibleAI from "./HelpPage/ResponsibleAI/ResponsibleAI";
import AISafety from "./HelpPage/AiSafety/AiSafety";
import SecurityAndPrivacy from "./HelpPage/SecurityAndPrivacy/SecurityAndPrivacy";
import HomomorphicEncryption from "./HomomorphicEncryption/HomomorphicEncryption";
import ContactForm from "./ContactForm/ContactForm";
import AIRiskDatabase from "./ThreatIntelligence/ThreatIntelligenceV2";
import PrivacyPolicy from "./AccountManagement/PrivacyPolicy";
import DocumentGen from "./DocumentGen/DocumentGen";
import AttackMitre from "./attackMitre/attackMitre";


function App() {
  return (
    <Router>
      <Main />
    </Router>
  );
}

function Main(){
  const [user, setUser] =useState(null);
  const [isFetching, setIsFetching] = useState(true);
  const location = useLocation();
  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
      console.log("Auth state changed:", currentUser); // Should log `null` after sign out
      setUser(currentUser);
      setIsFetching(false);
    });
    return () => unsubscribe();
  }, []);

  if (isFetching) {
    return (
      <div
        style={{
          backgroundImage: `linear-gradient(195deg, rgba(66, 66, 74, 0.6), rgba(25, 25, 25, 0.6)), url('bg.jpeg')`,
          backgroundSize: "cover",
          backgroundPosition: "center center",
          height: "100vh",
        }}
      >
        <h2>Loading...</h2>
      </div>
    );
  }

  const isLandingPage = location.pathname === "/";
  const isSignIn = location.pathname === "/SignIn";
  const isSignUp = location.pathname === "/SignUp";
  const isForgot = location.pathname === "/ForgotPassword";
  const isPriv = location.pathname === "/PrivacyPolicy"

  return(
    <div>
       {!isLandingPage && !isSignUp && !isSignIn && !isForgot && !isPriv && <Sidebar user={user} setUser={setUser} />}
      <div className={isLandingPage ? "no-sidebar-content" : "content"}>
        <Routes>
          <Route path='/' element={<Opening/>}/>
          <Route path="/SignIn" element={<SignIn user={user} />} />
          <Route path="/SignUp" element={<SignUp user={user} />} />
          <Route path='/ForgotPassword' element={ <ForgotPassword user={user}/>}/>
          <Route path='/MainPage' element={<ProtectedRoutes user={user}><MainPage /></ProtectedRoutes>}/>
          <Route path='/Accountability' element={<ProtectedRoutes user={user}><Accountability/></ProtectedRoutes>}/>
          <Route path='/Transparency' element={<ProtectedRoutes user={user}><Transparency/></ProtectedRoutes>}/>
          <Route path='/Fairness' element={<ProtectedRoutes user={user}><Fairness/></ProtectedRoutes>}/>
          <Route path='/Reliability' element={<ProtectedRoutes user={user}><Reliability/></ProtectedRoutes>}/>
          <Route path='/Privacy' element={<ProtectedRoutes user={user}><Privacy/></ProtectedRoutes>}/>
          <Route path='/Inclusiveness' element={<ProtectedRoutes user={user}><Inclusiveness/></ProtectedRoutes>}/>
          <Route path='/Risk_Management' element={<ProtectedRoutes user={user}><Risk_Management/></ProtectedRoutes>}/>
          <Route path='/Impact' element={<ProtectedRoutes user={user}><Impact/></ProtectedRoutes>}/>
          <Route path='/Data_Quaility_Framework' element={<ProtectedRoutes user={user}><Data_Quaility_Framework/></ProtectedRoutes>}/>
          <Route path='/AccountManagement' element={<ProtectedRoutes user={user}><AccountManage/></ProtectedRoutes>}/>
          <Route path='/ForgotPassword' element={<ProtectedRoutes user={user}><ForgotPassword/></ProtectedRoutes>}/>
          <Route path='/ConformityAnalysis' element={<ProtectedRoutes user={user}><Assessment/></ProtectedRoutes>}/>
          <Route path='/ThreatAnalysis' element={<ProtectedRoutes user={user}><ThreatAssessment/></ProtectedRoutes>}/>
          <Route path='/CoPilot' element={<ProtectedRoutes user={user}><CohereInterface/></ProtectedRoutes>}/>
          <Route path="/dashboard" element={<ProtectedRoutes user={user}><Dashboard/></ProtectedRoutes>}/>
          <Route path='/AdminDashboard' element={<ProtectedRoutes user={user}><AdminDashboard/></ProtectedRoutes>}/>
          <Route path='/AdminDashboard/AdminThreatPage' element={<ProtectedRoutes user={user}><AdminThreatAssessment/></ProtectedRoutes>}/>
          <Route path='/AdminDashboard/AdminConformityPage' element={<ProtectedRoutes user={user}><AdminConformityAssessment/></ProtectedRoutes>}/>
          <Route path='/AdminDashboard/AdminDashDash' element={<ProtectedRoutes user={user}><AdminDashDashboard/></ProtectedRoutes>}/>
          <Route path='/DataProfiler' element={<ProtectedRoutes user={user}><ProfilerOpening/></ProtectedRoutes>}/>
          {/* <Route path='/DataProfiler/ImagesPage' element={<ProtectedRoutes user={user}><ImagesPage/></ProtectedRoutes>}/>
          <Route path='/DataProfiler/TabularPage' element={<ProtectedRoutes user={user}><TabularPage/></ProtectedRoutes>}/> */}
          <Route path='/ThreatIntel' element={<ProtectedRoutes user={user}><ThreatIntel/></ProtectedRoutes>}/>
          <Route path='/ModelEvaluation' element={<ProtectedRoutes user={user}><ModelEvaluation/></ProtectedRoutes>}/>
          <Route path='/PrivacyMeter' element={<ProtectedRoutes user={user}><PrivacyMeter/></ProtectedRoutes>}/>
          <Route path='/DataSecurity' element={<ProtectedRoutes user={user}><DataSecurity/></ProtectedRoutes>}/>
          <Route path='/SecAIPage' element={<ProtectedRoutes user={user}><SecAIPage/></ProtectedRoutes>}/>
          <Route path='/FederatedLearning' element={<ProtectedRoutes user={user}><FederatedLearning/></ProtectedRoutes>}/>
          <Route path='/HomomorphicEncryption' element={<ProtectedRoutes user={user}><HomomorphicEncryption/></ProtectedRoutes>}/>
          <Route path='/ATLAS' element={<ProtectedRoutes user={user}><AttackMitre/></ProtectedRoutes>}/>
          <Route path='/ContactUs' element={<ProtectedRoutes user={user}><ContactForm/></ProtectedRoutes>}/>
          <Route path='/Support' element={<ProtectedRoutes user={user}><Support/></ProtectedRoutes>}/>
          <Route path='/Support/SecurityEducation' element={<ProtectedRoutes user={user}><SecurityEducation/></ProtectedRoutes>}/>
          <Route path='/Support/GeneralAI' element={<ProtectedRoutes user={user}><GeneralAI/></ProtectedRoutes>}/>
          <Route path='/Support/DataEthics' element={<ProtectedRoutes user={user}><DataEthics/></ProtectedRoutes>}/>
          <Route path='/Support/ResponsibleAI' element={<ProtectedRoutes user={user}><ResponsibleAI/></ProtectedRoutes>}/>
          <Route path='/Support/AISafety' element={<ProtectedRoutes user={user}><AISafety/></ProtectedRoutes>}/>
          <Route path='/Support/SecurityAndPrivacy' element={<ProtectedRoutes user={user}><SecurityAndPrivacy/></ProtectedRoutes>}/>
          <Route path='/AIRiskDatabase' element={<ProtectedRoutes user={user}><AIRiskDatabase/></ProtectedRoutes>}/>
          <Route path='/AIPolicyPro' element={<ProtectedRoutes user={user}><DocumentGen/></ProtectedRoutes>}/>
          <Route path='/PrivacyPolicy' element={<PrivacyPolicy user={user}/>}/>
        </Routes>
      </div> 
    </div>
  )
}

export default App;
